var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative max-w-full overflow-x-hidden",attrs:{"id":"app"}},[_c('MainHeader'),_c('AudioPlugin'),_c('MainLoading'),_c('ImageDialog'),_c('AreaDialog'),_c('VideoDialog'),_c('ShareDialog'),_c('MainDialog'),_c('router-view'),_c('DonationFooter'),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }